<template>
    <v-card
        color="transparent"
        outlined
    >
        <v-card-title>Intervjuspel</v-card-title>
        <v-card-subtitle>
            Antal spel: {{ number_interview_games }} | Bästa poäng: {{ best_score_interview_game }}
        </v-card-subtitle>
        <v-data-table
            v-if="number_interview_games"
            :items="games"
            :loading="loading"
            :headers="headers"
            :header-props="header_props"
            :server-items-length="total"
            :options.sync="options"
            @click:row="show_play_sequence_dialog"
            loading-text="Laddar..."
            hide-default-footer
        >
            <template #item._created="{ item }">
                {{ format_date(item['_created']) }}
            </template>
            <template #item.level="{ item }">
                <Trophy :level="item.level" />
            </template>
            <template #footer>
                <v-divider />
                <v-card-subtitle class="d-flex align-center justify-end">
                    <v-btn
                        @click="options.page -= 1"
                        :disabled="options.page === 1"
                        icon
                    >
                        <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                    {{ options.page }} / {{ pages }}
                    <v-btn
                        @click="options.page += 1"
                        :disabled="options.page === pages"
                        icon
                    >
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                </v-card-subtitle>
            </template>
        </v-data-table>
        <InterviewPlaySequence
            v-model="show_dialog"
            :play_sequence="play_sequence"
            :key="show_dialog"
        />
    </v-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { api_mixin } from '@/mixins/services/api_mixin'
import { date_mixin } from '@/mixins/services/date_mixin'
import Trophy from '@/components/Trophy.vue'
import InterviewPlaySequence from '@/components/user/InterviewPlaySequence.vue'

export default {
    name: 'Interview',
    props: {
        number_interview_games: {
            type: Number,
        },
        best_score_interview_game: {
            type: Number,
        },
        user_id: {
            type: String,
        },
    },
    mixins: [api_mixin, date_mixin],
    components: { InterviewPlaySequence, Trophy },
    data() {
        return {
            loading: true,
            games: [],
            total: -1,
            header_props: {
                sortByText: 'Sortera',
            },
            headers: [
                {
                    text: 'Datum',
                    value: '_created',
                },
                {
                    text: 'Poäng',
                    value: 'score',
                },
                {
                    text: 'Nivå',
                    value: 'level',
                    sortable: false,
                    align: 'center',
                },
            ],
            options: {
                sortBy: ['-_created'],
                sortDesc: [false],
                itemsPerPage: 20,
                page: 1,
                mustSort: true,
            },
            play_sequence: [],
            show_dialog: false,
        }
    },
    computed: {
        pages() {
            const pages = Math.ceil(this.total / this.options.itemsPerPage)
            return pages <= 0 ? 1 : pages
        },
        ...mapGetters([]),
        ...mapState([]),
    },
    watch: {
        options: {
            handler() {
                this.load_interview_games()
            },
            deep: true,
        },
    },
    methods: {
        async load_interview_games() {
            this.loading = true
            const [sort_by] = this.options.sortBy
            const [sort_desc] = this.options.sortDesc
            const sort = sort_desc ? '-' + sort_by : '' + sort_by
            const max_results = this.options.itemsPerPage
            const page = this.options.page
            const result = await this.api_get({
                url: 'x-u2work--interview-game-results',
                params: {
                    where: {
                        user: this.user_id,
                    },
                    sort: sort,
                    max_results: max_results,
                    page: page,
                },
            })
            this.games = result.data['_items']
            this.total = result.data['_meta']['total']
            this.loading = false
        },
        show_play_sequence_dialog(data) {
            this.play_sequence.splice(0, this.play_sequence.length, ...data['play_sequence'])
            this.show_dialog = true
        },
        ...mapActions([]),
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {
        this.load_interview_games()
    },
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
}
</script>

<style scoped lang="sass">
::v-deep tbody tr:hover
  cursor: pointer
</style>
